import { Link } from "react-router-dom";
import { Seo } from "@/components/common/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" description="The page you requested could not be found on rigorfield.com." path="/404" noindex />
      <section className="on-dark relative flex min-h-[80vh] items-center overflow-hidden bg-ink pt-24 text-white" data-testid="not-found">
        <div className="container-x relative">
          <p className="eyebrow mb-6">Error 404 · Finding RF-404</p>
          <h1 className="text-5xl font-extrabold leading-[0.95] sm:text-7xl lg:text-8xl">This page didn't<br /><span className="text-teal-bright">pass inspection.</span></h1>
          <p className="lede mt-8 max-w-xl">The link may be outdated or mistyped. Severity: low. Recommended remediation below.</p>
          <div className="mt-10 flex flex-wrap gap-3">
            <Link to="/" className="btn-primary" data-testid="notfound-home">Back to home</Link>
            <Link to="/services" className="btn-ghost">Explore services</Link>
            <Link to="/sitemap" className="btn-ghost">HTML sitemap</Link>
          </div>
        </div>
      </section>
    </>
  );
}
